import {ExportDefaultToggle} from './exportDefaults';

// T4-152: Xero has one export toggle, defaulted per connected organisation. The saved value lives on
// the organisation's bill_from row; a missing row or null means no Admin has saved one, shown as off
// (the value the new-design Export to Xero window starts with).

export type XeroExportDefaultField = 'projectInDescription';
export type XeroExportDefaults = Record<XeroExportDefaultField, boolean>;
export type XeroOrganization = {tenantId: string; organization: string};
export type StoredXeroBillFrom = {
	readonly integration: string;
	readonly externalId: string;
	readonly exportProjectInDescription: boolean | null | undefined;
};

export const XERO_EXPORT_DEFAULT_TOGGLES: ReadonlyArray<ExportDefaultToggle<XeroExportDefaultField>> = [
	{
		field: 'projectInDescription',
		labelId: 'invoicing.xero.project_in_description',
		helperId: 'integrations.quickbooks.export_defaults.project_name_helper',
	},
];

// One organisation's row; a missing row or null (never saved) is off.
export const xeroExportDefaultsOf = (
	billFrom: Pick<StoredXeroBillFrom, 'exportProjectInDescription'> | null | undefined
): XeroExportDefaults => ({projectInDescription: billFrom?.exportProjectInDescription === true});

export const xeroExportDefaultsFor = (
	billFroms: ReadonlyArray<StoredXeroBillFrom | null> | null | undefined,
	tenantId: string
): XeroExportDefaults =>
	xeroExportDefaultsOf((billFroms || []).find(b => b && b.integration === 'XERO' && b.externalId === tenantId));

export const shouldShowXeroExportDefaults = (hasFlag: boolean, organizations: ReadonlyArray<XeroOrganization>) =>
	hasFlag && organizations.length > 0;
